export const FANDOM_CONTEXT_UPDATE = "fandomContextUpdate";

/**
 * Waits for the {@link window.fandomContext.tracking} object to be ready.
 * This object is asynchronously set by IdentityEngine and is available shortly after the first consent signal is sent.
 * When it resolves, we can start accessing Tracking properties. Before that happens, those can be undefined.
 */
export const waitForFandomContextTracking = (container: Window = window) => {
  const check = () =>
    container.fandomContext?.tracking !== undefined &&
    container.fandomContext.tracking.pvNumber &&
    container.fandomContext.tracking.pvNumberGlobal &&
    container.fandomContext.tracking.pvUID;

  return new Promise<void>((resolve) => {
    if (check()) {
      return resolve();
    }

    const listener = () => {
      if (check()) {
        container.removeEventListener(FANDOM_CONTEXT_UPDATE, listener);
        resolve();
      }
    };
    container.addEventListener(FANDOM_CONTEXT_UPDATE, listener);
  });
};
